import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { Check as CheckIcon } from '@material-ui/icons'

export function getNumber(props) {
    const { reverse, zero_number, len, index } = props

    if (zero_number) return reverse ? (len - index) : index - 1
    else return reverse ? (len - index + 1) : index
}

function StepIconComponent(props) {
    const { stepIconClasses, reverse, zero_number, len, icon, active } = props

    return (
        <div className={clsx(stepIconClasses.root, { [stepIconClasses.active]: active })}>
            {active ? <CheckIcon/> : <Typography variant="button">{getNumber({ reverse, zero_number, len, index: icon })}</Typography>}
        </div>
    )  
}

export default StepIconComponent